import { clockStyle, sizeMapWidth } from "./ResultClockDark";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgResultClockLight = function SvgResultClockLight(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: sizeMapWidth[size] || 72,
    viewBox: "0 0 72 72",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#C0D2E7",
      fillOpacity: 0.12,
      d: "M36 9C21.088 9 9 21.088 9 36s12.088 27 27 27 27-12.088 27-27S50.912 9 36 9ZM3 36C3 17.775 17.775 3 36 3s33 14.775 33 33-14.775 33-33 33S3 54.225 3 36Z"
    }), /*#__PURE__*/_jsx("circle", {
      cx: 36,
      cy: 36,
      r: 33,
      fill: "#C0D2E7",
      fillOpacity: 0.12
    }), /*#__PURE__*/_jsx("path", {
      d: "M36 15C37.6569 15 39 16.2894 39 17.88L39 36.12C39 37.7106 37.6569 39 36 39C34.3431 39 33 37.7106 33 36.12L33 17.88C33 16.2894 34.3431 15 36 15Z",
      fill: "#121214"
    }), /*#__PURE__*/_jsx("path", {
      d: "M36 15C37.6569 15 39 16.2894 39 17.88L39 36.12C39 37.7106 37.6569 39 36 39C34.3431 39 33 37.7106 33 36.12L33 17.88C33 16.2894 34.3431 15 36 15Z",
      fill: "#121214",
      style: clockStyle
    })]
  });
};
export default SvgResultClockLight;